//import services from './services.js';
import { GetAuditOrderById, GetERP_OrderById } from '@api/orderApi.js';
import NProgress from 'nprogress';
import { lg, cloneDeep, util, isCorrectVal, isDate } from 'utils';
import $http from '$http';

//组件
// import baseInfoForm from 'agent-base-info';

export default {
    //mixins: [services],
    components: {},
    props: {},
    data() {
        return {
            isUpdate: false,
            dialogVisible: false,
            btnLoading: false,
            Form: {},
            dialogImageUrl: "",
            PictureVisible: false,
            ChangeOrderTotalPriceParam: this.getChangeOrderTotalPriceParam()
        }
    },
    computed: {
        getActualPrice() {
            if ($.trim(this.ChangeOrderTotalPriceParam.TotalPrice).length == 0) {
                return this.Form.OrderActualPrice;
            }
            if (this.ChangeOrderTotalPriceParam.TotalPrice > this.Form.DisPrice) {
                return (this.ChangeOrderTotalPriceParam.TotalPrice - this.Form.DisPrice);
            } else {
                return 0;
            }
        }
    },
    methods: {
        getChangeOrderTotalPriceParam() {
            return cloneDeep({
                "OrderId": "",
                "TotalPrice": ""
            });
        },
        getErpConfig() {
            return cloneDeep({
                id: "",
                isUpdate: false,
            });
        },
        show(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            this.isUpdate = opts.isUpdate;
            this.getInitData(opts.id);
        },
        getInitData(id) {
            let para = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: id
            };
            let $msg = this.$message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });
            GetAuditOrderById(para).then(res => {
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.Form = Data;
                    this.ChangeOrderTotalPriceParam.TotalPrice = this.Form.CurrentOrderPrice
                    this.ChangeOrderTotalPriceParam.OrderId = this.Form.OrderId;
                });
                $msg.close();
                this.dialogVisible = true;
            });
        },
        LookPicture(Url) {
            this.dialogImageUrl = Url;
            this.PictureVisible = true;
        },
        updateFn() {
            let params = this.ChangeOrderTotalPriceParam;
            this.btnLoading = true;
            $http.post('api/Order/ChangeOrderTotalPrice', params).then(res => {
                this.btnLoading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reloadList');// 向上派发 toggle事件
                });
            });
        },
        closeCallback() {
            this.ChangeOrderTotalPriceParam = this.getChangeOrderTotalPriceParam();
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/components/waitPayOrderInfo/vm.js